<!--
Author: jiangli
Date: 2021-03-25
Desc: 政策法规
 -->
<template>
    <div :class="'bizcomp-safe-center bizcomp ' + className">
        <comp-title :title="title" />
        <div class="content">
            <p class="content-title">
                《证券期货投资者适当性管理办法》
            </p>
            <p> &emsp;&emsp;（2016年5月26日中国证券监督管理委员会第7次主席办公会议审议通过，根据2020年10月30日中国证券监督管理委员会《关于修改、废止部分证券期货规章的决定》第一次修正，根据2022年8月12日中国证券监督管理委员会《关于修改、废止部分证券期货规章的决定》第二次修正）</p>
            <p><b>第一条</b> 为了规范证券期货投资者适当性管理，维护投资者合法权益，根据《中华人民共和国证券法》（以下简称《证券法》）、《中华人民共和国证券投资基金法》（以下简称《证券投资基金法》）、《中华人民共和国期货和衍生品法》（以下简称《期货和衍生品法》）、《证券公司监督管理条例》《期货交易管理条例》及其他相关法律、行政法规，制定本办法。</p>
            <p><b>第二条</b> 向投资者销售公开或者非公开发行的证券、公开或者非公开募集的证券投资基金和股权投资基金（包括创业投资基金，以下简称基金）、公开或者非公开转让的期货及其他衍生产品，或者为投资者提供相关业务服务的，适用本办法。</p>
            <p>本办法所称投资者，包括《证券法》规定的投资者，《证券投资基金法》规定的投资人、基金份额持有人，以及《期货和衍生品法》规定的交易者等。</p>
            <p><b>第三条</b> 向投资者销售证券期货产品或者提供证券期货服务的机构（以下简称经营机构）应当遵守法律、行政法规、本办法及其他有关规定，在销售产品或者提供服务的过程中，勤勉尽责，审慎履职，全面了解投资者情况，深入调查分析产品或者服务信息，科学有效评估，充分揭示风险，基于投资者的不同风险承受能力以及产品或者服务的不同风险等级等因素，提出明确的适当性匹配意见，将适当的产品或者服务销售或者提供给适合的投资者，并对违法违规行为承担法律责任。</p>
            <p><b>第四条</b> 投资者应当在了解产品或者服务情况，听取经营机构适当性意见的基础上，根据自身能力审慎决策，独立承担投资风险。</p>
            <p>经营机构的适当性匹配意见不表明其对产品或者服务的风险和收益做出实质性判断或者保证。</p>
            <p><b>第五条</b> 中国证券监督管理委员会（以下简称中国证监会）及其派出机构依照法律、行政法规、本办法及其他相关规定，对经营机构履行适当性义务进行监督管理。</p>
            <p>证券期货交易场所、登记结算机构及中国证券业协会、中国期货业协会、中国证券投资基金业协会（以下统称行业协会）等自律组织对经营机构履行适当性义务进行自律管理。</p>
            <p><b>第六条</b> 经营机构向投资者销售产品或者提供服务时，应当了解投资者的下列信息：</p>
            <p>（一）自然人的姓名、住址、职业、年龄、联系方式，法人或者其他组织的名称、注册地址、办公地址、性质、资质及经营范围等基本信息；</p>
            <p>（二）收入来源和数额、资产、债务等财务状况；</p>
            <p>（三）投资相关的学习、工作经历及投资经验；</p>
            <p>（四）投资期限、品种、期望收益等投资目标；</p>
            <p>（五）风险偏好及可承受的损失；</p>
            <p>（六）诚信记录；</p>
            <p>（七）实际控制投资者的自然人和交易的实际受益人；</p>
            <p>（八）法律法规、自律规则规定的投资者准入要求相关信息；</p>
            <p>（九）其他必要信息。</p>
            <p><b>第七条</b> 投资者分为普通投资者与专业投资者。普通投资者在信息告知、风险警示、适当性匹配等方面享有特别保护。</p>
            <p><b>第八条</b> 符合下列条件之一的是专业投资者：</p>
            <p>（一）经有关金融监管部门批准设立的金融机构，包括证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司等；经行业协会备案或者登记的证券公司子公司、期货公司子公司、私募基金管理人。</p>
            <p>（二）上述机构面向投资者发行的理财产品，包括但不限于证券公司资产管理产品、基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协会备案的私募基金。</p>
            <p>（三）社会保障基金、企业年金等养老基金，慈善基金等社会公益基金，合格境外机构投资者（QFII）、人民币合格境外机构投资者（RQFII）。</p>
            <p>（四）同时符合下列条件的法人或者其他组织：</p>
            <p>1.最近1年末净资产不低于2000万元；</p>
            <p>2.最近1年末金融资产不低于1000万元；</p>
            <p>3.具有2年以上证券、基金、期货、黄金、外汇等投资经历。</p>
            <p>（五）同时符合下列条件的自然人：</p>
            <p>1.金融资产不低于500万元，或者最近3年个人年均收入不低于50万元；</p>
            <p>2.具有2年以上证券、基金、期货、黄金、外汇等投资经历，或者具有2年以上金融产品设计、投资、风险管理及相关工作经历，或者属于本条第（一）项规定的专业投资者的高级管理人员、获得职业资格认证的从事金融相关业务的注册会计师和律师。</p>
            <p>前款所称金融资产，是指银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他衍生产品等。</p>
            <p><b>第九条</b> 经营机构可以根据专业投资者的业务资格、投资实力、投资经历等因素，对专业投资者进行细化分类和管理。</p>
            <p><b>第十条</b> 专业投资者之外的投资者为普通投资者。</p>
            <p>经营机构应当按照有效维护投资者合法权益的要求，综合考虑收入来源、资产状况、债务、投资知识和经验、风险偏好、诚信状况等因素，确定普通投资者的风险承受能力，对其进行细化分类和管理。</p>
            <p><b>第十一条</b> 普通投资者和专业投资者在一定条件下可以互相转化。</p>
            <p>符合本办法第八条第（四）、（五）项规定的专业投资者，可以书面告知经营机构选择成为普通投资者，经营机构应当对其履行相应的适当性义务。</p>
            <p>符合下列条件之一的普通投资者可以申请转化成为专业投资者，但经营机构有权自主决定是否同意其转化：</p>
            <p>（一）最近1年末净资产不低于1000万元，最近1年末金融资产不低于500万元，且具有1年以上证券、基金、期货、黄金、外汇等投资经历的除专业投资者外的法人或其他组织；</p>
            <p>（二）金融资产不低于300万元或者最近3年个人年均收入不低于30万元，且具有1年以上证券、基金、期货、黄金、外汇等投资经历或者1年以上金融产品设计、投资、风险管理及相关工作经历的自然人投资者。</p>
            <p><b>第十二条</b> 普通投资者申请成为专业投资者应当以书面形式向经营机构提出申请并确认自主承担可能产生的风险和后果，提供相关证明材料。</p>
            <p>经营机构应当通过追加了解信息、投资知识测试或者模拟交易等方式对投资者进行谨慎评估，确认其符合前条要求，说明对不同类别投资者履行适当性义务的差别，警示可能承担的投资风险，告知申请的审查结果及其理由。</p>
            <p><b>第十三条</b> 经营机构应当告知投资者，其根据本办法第六条规定所提供的信息发生重要变化、可能影响分类的，应及时告知经营机构。经营机构应当建立投资者评估数据库并及时更新，充分使用已了解信息和已有评估结果，避免重复采集，提高评估效率。</p>
            <p><b>第十四条</b> 中国证监会、自律组织在针对特定市场、产品或者服务制定规则时，可以考虑风险性、复杂性以及投资者的认知难度等因素，从资产规模、收入水平、风险识别能力和风险承担能力、投资认购最低金额等方面，规定投资者准入要求。投资者准入要求包含资产指标的，应当规定投资者在购买产品或者接受服务前一定时期内符合该指标。</p>
            <p>现有市场、产品或者服务规定投资者准入要求的，应当符合前款规定。</p>
            <p><b>第十五条</b> 经营机构应当了解所销售产品或者所提供服务的信息，根据风险特征和程度，对销售的产品或者提供的服务划分风险等级。</p>
            <p><b>第十六条</b> 划分产品或者服务风险等级时应当综合考虑以下因素：</p>
            <p>（一）流动性；</p>
            <p>（二）到期时限；</p>
            <p>（三）杠杆情况；</p>
            <p>（四）结构复杂性；</p>
            <p>（五）投资单位产品或者相关服务的最低金额；</p>
            <p>（六）投资方向和投资范围；</p>
            <p>（七）募集方式；</p>
            <p>（八）发行人等相关主体的信用状况；</p>
            <p>（九）同类产品或者服务过往业绩；</p>
            <p>（十）其他因素。</p>
            <p>涉及投资组合的产品或者服务，应当按照产品或者服务整体风险等级进行评估。</p>
            <p><b>第十七条</b> 产品或者服务存在下列因素的，应当审慎评估其风险等级：</p>
            <p>（一）存在本金损失的可能性，因杠杆交易等因素容易导致本金大部分或者全部损失的产品或者服务；</p>
            <p>（二）产品或者服务的流动变现能力，因无公开交易市场、参与投资者少等因素导致难以在短期内以合理价格顺利变现的产品或者服务；</p>
            <p>（三）产品或者服务的可理解性，因结构复杂、不易估值等因素导致普通人难以理解其条款和特征的产品或者服务；</p>
            <p>（四）产品或者服务的募集方式，涉及面广、影响力大的公募产品或者相关服务；</p>
            <p>（五）产品或者服务的跨境因素，存在市场差异、适用境外法律等情形的跨境发行或者交易的产品或者服务；</p>
            <p>（六）自律组织认定的高风险产品或者服务；</p>
            <p>（七）其他有可能构成投资风险的因素。</p>
            <p><b>第十八条</b> 经营机构应当根据产品或者服务的不同风险等级，对其适合销售产品或者提供服务的投资者类型作出判断，根据投资者的不同分类，对其适合购买的产品或者接受的服务作出判断。</p>
            <p><b>第十九条</b> 经营机构告知投资者不适合购买相关产品或者接受相关服务后，投资者主动要求购买风险等级高于其风险承受能力的产品或者接受相关服务的，经营机构在确认其不属于风险承受能力最低类别的投资者后，应当就产品或者服务风险高于其承受能力进行特别的书面风险警示，投资者仍坚持购买的，可以向其销售相关产品或者提供相关服务。</p>
            <p><b>第二十条</b> 经营机构向普通投资者销售高风险产品或者提供相关服务，应当履行特别的注意义务，包括制定专门的工作程序，追加了解相关信息，告知特别的风险点，给予普通投资者更多的考虑时间，或者增加回访频次等。</p>
            <p><b>第二十一条</b> 经营机构应当根据投资者和产品或者服务的信息变化情况，主动调整投资者分类、产品或者服务分级以及适当性匹配意见，并告知投资者上述情况。</p>
            <p><b>第二十二条</b> 禁止经营机构进行下列销售产品或者提供服务的活动：</p>
            <p>（一）向不符合准入要求的投资者销售产品或者提供服务；</p>
            <p>（二）向投资者就不确定事项提供确定性的判断，或者告知投资者有可能使其误认为具有确定性的意见；</p>
            <p>（三）向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务；</p>
            <p>（四）向普通投资者主动推介不符合其投资目标的产品或者服务；</p>
            <p>（五）向风险承受能力最低类别的投资者销售或者提供风险等级高于其风险承受能力的产品或者服务；</p>
            <p>（六）其他违背适当性要求，损害投资者合法权益的行为。</p>
            <p><b>第二十三条</b> 经营机构向普通投资者销售产品或者提供服务前，应当告知下列信息：</p>
            <p>（一）可能直接导致本金亏损的事项；</p>
            <p>（二）可能直接导致超过原始本金损失的事项；</p>
            <p>（三）因经营机构的业务或者财产状况变化，可能导致本金或者原始本金亏损的事项；</p>
            <p>（四）因经营机构的业务或者财产状况变化，影响客户判断的重要事由；</p>
            <p>（五）限制销售对象权利行使期限或者可解除合同期限等全部限制内容；</p>
            <p>（六）本办法第二十九条规定的适当性匹配意见。</p>
            <p><b>第二十四条</b> 经营机构对投资者进行告知、警示，内容应当真实、准确、完整，不存在虚假记载、误导性陈述或者重大遗漏，语言应当通俗易懂；告知、警示应当采用书面形式送达投资者，并由其确认已充分理解和接受。</p>
            <p><b>第二十五条</b> 经营机构通过营业网点向普通投资者进行本办法第十二条、第二十条、第二十一条和第二十三条规定的告知、警示，应当全过程录音或者录像；通过互联网等非现场方式进行的，经营机构应当完善配套留痕安排，由普通投资者通过符合法律、行政法规要求的电子方式进行确认。</p>
            <p><b>第二十六条</b> 经营机构委托其他机构销售本机构发行的产品或者提供服务，应当审慎选择受托方，确认受托方具备代销相关产品或者提供服务的资格和落实相应适当性义务要求的能力，应当制定并告知代销方所委托产品或者提供服务的适当性管理标准和要求，代销方应当严格执行，但法律、行政法规、中国证监会其他规章另有规定的除外。</p>
            <p><b>第二十七条</b> 经营机构代销其他机构发行的产品或者提供相关服务，应当在合同中约定要求委托方提供的信息，包括本办法第十六条、第十七条规定的产品或者服务分级考虑因素等，自行对该信息进行调查核实，并履行投资者评估、适当性匹配等适当性义务。委托方不提供规定的信息、提供信息不完整的，经营机构应当拒绝代销产品或者提供服务。</p>
            <p><b>第二十八条</b> 对在委托销售中违反适当性义务的行为，委托销售机构和受托销售机构应当依法承担相应法律责任，并在委托销售合同中予以明确。</p>
            <p><b>第二十九条</b> 经营机构应当制定适当性内部管理制度，明确投资者分类、产品或者服务分级、适当性匹配的具体依据、方法、流程等，严格按照内部管理制度进行分类、分级，定期汇总分类、分级结果，并对每名投资者提出匹配意见。</p>
            <p>经营机构应当制定并严格落实与适当性内部管理有关的限制不匹配销售行为、客户回访检查、评估与销售隔离等风控制度，以及培训考核、执业规范、监督问责等制度机制，不得采取鼓励不适当销售的考核激励措施，确保从业人员切实履行适当性义务。</p>
            <p><b>第三十条</b> 经营机构应当每半年开展一次适当性自查，形成自查报告。发现违反本办法规定的问题，应当及时处理并主动报告住所地中国证监会派出机构。</p>
            <p><b>第三十一条</b> 鼓励经营机构将投资者分类政策、产品或者服务分级政策、自查报告在公司网站或者符合中国证监会规定条件的媒体进行披露。</p>
            <p><b>第三十二条</b> 经营机构应当按照相关规定妥善保存其履行适当性义务的相关信息资料，防止泄露或者被不当利用，接受中国证监会及其派出机构和自律组织的检查。对匹配方案、告知警示资料、录音录像资料、自查报告等的保存期限不得少于20年。</p>
            <p><b>第三十三条</b> 投资者购买产品或者接受服务，按规定需要提供信息的，所提供的信息应当真实、准确、完整。投资者根据本办法第六条规定所提供的信息发生重要变化、可能影响其分类的，应当及时告知经营机构。</p>
            <p>投资者不按照规定提供相关信息，提供信息不真实、不准确、不完整的，应当依法承担相应法律责任，经营机构应当告知其后果，并拒绝向其销售产品或者提供服务。</p>
            <p><b>第三十四条</b> 经营机构应当妥善处理适当性相关的纠纷，与投资者协商解决争议，采取必要措施支持和配合投资者提出的调解。经营机构履行适当性义务存在过错并造成投资者损失的，应当依法承担相应法律责任。</p>
            <p>经营机构与普通投资者发生纠纷的，经营机构应当提供相关资料，证明其已向投资者履行相应义务。</p>
            <p><b>第三十五条</b> 中国证监会及其派出机构在监管中应当审核或者关注产品或者服务的适当性安排，对适当性制度落实情况进行检查，督促经营机构严格落实适当性义务，强化适当性管理。</p>
            <p><b>第三十六条</b> 证券期货交易场所应当制定完善本市场相关产品或者服务的适当性管理自律规则。</p>
            <p>行业协会应当制定完善会员落实适当性管理要求的自律规则，制定并定期更新本行业的产品或者服务风险等级名录以及本办法第十九条、第二十二条规定的风险承受能力最低的投资者类别，供经营机构参考。经营机构评估相关产品或者服务的风险等级不得低于名录规定的风险等级。</p>
            <p>证券期货交易场所、行业协会应当督促、引导会员履行适当性义务，对备案产品或者相关服务应当重点关注高风险产品或者服务的适当性安排。</p>
            <p><b>第三十七条</b> 经营机构违反本办法规定的，中国证监会及其派出机构可以对经营机构及其直接负责的主管人员和其他直接责任人员，采取责令改正、监管谈话、出具警示函等监督管理措施。</p>
            <p><b>第三十八条</b> 证券公司、期货公司违反本办法规定，存在较大风险或者风险隐患的，中国证监会及其派出机构可以按照《证券法》第一百四十条、《期货和衍生品法》第七十三条、《证券公司监督管理条例》第七十条、《期货交易管理条例》第五十五条的规定，采取监督管理措施。</p>
            <p><b>第三十九条</b> 违反本办法第六条、第十八条、第十九条、第二十条、第二十一条、第二十二条第（三）项至第（六）项、第二十三条、第二十四条、第三十三条规定的，按照《证券法》第一百九十八条、《证券投资基金法》第一百三十七条、《期货和衍生品法》第一百三十五条、《证券公司监督管理条例》第八十四条、《期货交易管理条例》第六十七条予以处理。</p>
            <p><b>第四十条</b> 违反本办法第二十二条第（一）项至第（二）项、第二十六条、第二十七条规定的，按照《证券投资基金法》第一百三十五条、《期货和衍生品法》第一百三十五条、《证券公司监督管理条例》第八十三条、《期货交易管理条例》第六十六条予以处理。</p>
            <p><b>第四十一条</b> 经营机构有下列情形之一的，给予警告，并处以3万元以下罚款；对直接负责的主管人员和其他直接责任人员，给予警告，并处以3万元以下罚款：</p>
            <p>（一）违反本办法第十条，未按规定对普通投资者进行细化分类和管理的；</p>
            <p>（二）违反本办法第十一条、第十二条，未按规定进行投资者类别转化的；</p>
            <p>（三）违反本办法第十三条，未建立或者更新投资者评估数据库的；</p>
            <p>（四）违反本办法第十五条，未按规定了解所销售产品或者所提供服务信息或者履行分级义务的；</p>
            <p>（五）违反本办法第十六条、第十七条，未按规定划分产品或者服务风险等级的；</p>
            <p>（六）违反本办法第二十五条，未按规定录音录像或者采取配套留痕安排的；</p>
            <p>（七）违反本办法第二十九条，未按规定制定或者落实适当性内部管理制度和相关制度机制的；</p>
            <p>（八）违反本办法第三十条，未按规定开展适当性自查的；</p>
            <p>（九）违反本办法第三十二条，未按规定妥善保存相关信息资料的；</p>
            <p>（十）违反本办法第六条、第十八条至第二十四条、第二十六条、第二十七条、第三十三条规定，未构成《证券法》第一百九十八条，《证券投资基金法》第一百三十五条、第一百三十七条，《期货和衍生品法》第一百三十五条，《证券公司监督管理条例》第八十三条、第八十四条，《期货交易管理条例》第六十六条、第六十七条规定情形的。</p>
            <p><b>第四十二条</b> 经营机构从业人员违反相关法律法规和本办法规定，情节严重的，中国证监会可以依法采取市场禁入的措施。</p>
            <p><b>第四十三条</b> 本办法自2017年7月1日起施行。</p>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "PolicyAndLaw",
    mixins: [mixin]
};
</script>

<style scoped lang="scss">
@import '../../assets/css/varibles';
.content{
    padding: 20px;
     &-title{
        color:red;
        text-align:center;
        padding-bottom: 15px;
        font-size: 15px;
    }
}
</style>
